module.exports = __webpack_public_path__ + "img/sort_arrows.bcb1bda3.svg";